export function on(element, eventName, callback, options) {
  element.addEventListener(eventName, callback, options);
  return function () {
    return element.removeEventListener(eventName, callback, options);
  };
}